import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {ICom0113PState, IDeptState, IDutyCdState} from '../../models/com/com0113p_model';
  
const initialState: ICom0113PState = {
    deptList : [],      // 부서목록
    dutyCdList : [],    // 직책코드목록
}

export const com0113p_Slice = createSlice({
    name: "com0113p_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , dutyCdList: state.dutyCdList});
        },
        setDeptList: (state, action:PayloadAction<IDeptState[]>) => {
            state.deptList = action.payload;
        },
        setDeptItem: (state, action:PayloadAction<IDeptState>) => {
            const tmpArr:IDeptState[] = state.deptList.map((item) => {
                return item.deptCd === action.payload.deptCd ? { ...item, ...action.payload } : item;
            });

            return {
                ...state,
                deptList : tmpArr
            }
        },
        setDutyCdList: (state, action:PayloadAction<IDutyCdState[]>) => {
            state.dutyCdList = action.payload;
        },
        addToDeptList: (state, action:PayloadAction<IDeptState>) => {
            const tmpArr = [...state.deptList];
            const currDept = tmpArr.filter((item:IDeptState) => {
                return item.deptCd === action.payload.deptCd;
            });

            if (!currDept || currDept.length < 1) {
                tmpArr.push(action.payload);
            }

            return {
                ...state,
                deptList : tmpArr
            }
        },    
    },
});

export default com0113p_Slice.reducer;
export const Com0113pAction  = com0113p_Slice.actions;
export const Com0113pReducer = com0113p_Slice.reducer;